import PasswordChangeRequiredPage from "components/pages/PasswordChangeRequiredPage";
import "./styles.css";

/**
 * @name CaptureSoftTokenActivationActivateTokenPasswordChange
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenPasswordChange(props) {
    return <PasswordChangeRequiredPage className="capture-soft-token-activation" />;
}